/*
  innvolo-hoja.js
  La hoja que sube desde abajo en celular. La usan dos plantillas:

    · ficha de producto — el panel de cotización (decisión 1B + 1C)
    · colección         — los filtros (decisión 2B)

  Por eso vive en su propio archivo y no dentro del JS de ninguna de las dos.

  EL MISMO DOM SIRVE PARA LAS DOS ANCHURAS
  No se clona ni se mueve nada. En escritorio, `.innvolo-hoja` no hace nada: la
  columna de filtros y el panel del cotizador se ven como siempre. Todo el
  comportamiento de hoja —y todo su CSS— vive por debajo de 860 px. Este script
  comprueba el ancho antes de tocar nada, y si la ventana crece con la hoja
  abierta, la cierra y devuelve la página a su sitio.

  CONTRATO
    <button data-innvolo-hoja-abre="filtros">        abre
    <div class="innvolo-hoja" data-innvolo-hoja="filtros">   la hoja
    <button data-innvolo-hoja-cierra>               cierra (opcional)

  El velo lo fabrica este script, para no repetirlo en cada plantilla.
*/

(function () {
  'use strict';

  var hojas = document.querySelectorAll('[data-innvolo-hoja]');
  if (!hojas.length) return;

  var angosto = window.matchMedia('(max-width: 860px)');
  var velo = null;
  var abierta = null;
  var devolverFoco = null;

  function creaVelo() {
    if (velo) return velo;
    velo = document.createElement('div');
    velo.className = 'innvolo-velo-hoja';
    velo.dataset.innvoloAbre = 'no';
    velo.addEventListener('click', cierra);
    document.body.appendChild(velo);
    return velo;
  }

  function abre(nombre, origen) {
    if (!angosto.matches) return;

    var hoja = document.querySelector('[data-innvolo-hoja="' + nombre + '"]');
    if (!hoja) return;

    if (abierta) cierra();

    creaVelo().dataset.innvoloAbre = 'si';
    hoja.dataset.innvoloAbre = 'si';
    hoja.setAttribute('aria-modal', 'true');
    hoja.setAttribute('role', 'dialog');

    /* El fondo no se desplaza detrás de la hoja. */
    document.documentElement.dataset.innvoloQuieto = 'si';

    abierta = hoja;
    devolverFoco = origen || null;

    /* El foco entra en la hoja: si se queda en el botón de atrás, el lector de
       pantalla sigue leyendo la página que hay debajo. */
    var primero = hoja.querySelector(
      'button:not([disabled]), a[href], input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])'
    );
    if (primero) primero.focus({ preventScroll: true });
  }

  function cierra() {
    if (!abierta) return;

    abierta.dataset.innvoloAbre = 'no';
    abierta.removeAttribute('aria-modal');
    abierta.removeAttribute('role');
    if (velo) velo.dataset.innvoloAbre = 'no';
    delete document.documentElement.dataset.innvoloQuieto;

    if (devolverFoco && devolverFoco.focus) devolverFoco.focus({ preventScroll: true });

    abierta = null;
    devolverFoco = null;
  }

  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest('[data-innvolo-hoja-abre]');
    if (boton) {
      ev.preventDefault();
      abre(boton.dataset.innvoloHojaAbre, boton);
      return;
    }

    if (ev.target.closest('[data-innvolo-hoja-cierra]')) {
      ev.preventDefault();
      cierra();
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') cierra();
  });

  /* Si la ventana se ensancha, la hoja deja de tener sentido: en escritorio ese
     mismo bloque es una columna normal. */
  var alCambiar = function () {
    if (!angosto.matches) cierra();
  };
  if (angosto.addEventListener) {
    angosto.addEventListener('change', alCambiar);
  } else if (angosto.addListener) {
    angosto.addListener(alCambiar);
  }
})();
